export default __webpack_public_path__ + "static/media/a047-icon3.c1fc7d02.png";